import React from 'react'
import { Button, Icon } from '@equinor/eds-core-react'
import styled from 'styled-components'

interface IFilterButton {
    onClick?: () => void
    count: number
}

const FilterButton: React.FC<IFilterButton> = ({ onClick, count }) => (
    <FilterButtonStyled variant="outlined" onClick={onClick}>
        <Icon name="filter_alt" />
        Filter
        {count > 0 && <Badge>{count}</Badge>}
    </FilterButtonStyled>
)

const FilterButtonStyled = styled(Button)`
    border: 1px solid;
    width: 105px;
    height: 38px;
    border: none;
    padding: 0 16px;

    @media (max-width: 1024px) {
        border: 1px solid;
    }

    @media (max-width: 400px) {
        border: 1px solid;
        flex: 1;
        width: 85px;
        height: 40px;
    }
`
const Badge = styled.div`
    position: absolute;
    top: -5px;
    right: 5px;
    background-color: #cfe7e9;
    color: #1f6369;
    border-radius: 50%;
    font-size: 12px;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export default FilterButton
